var exports = {
  "y": "xe7b6e3d6--214e78--divider",
};

module.exports = exports;
